
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.6733 13.4189L9.25415 7.99976L14.6733 2.58063C15.0196 2.23422 15.0196 1.67262 14.6732 1.32627C14.3269 0.979863 13.7652 0.979863 13.4188 1.32627L7.99974 6.74534L2.58063 1.32621C2.23428 0.979804 1.67262 0.979804 1.32621 1.32621C0.979804 1.67262 0.979804 2.23422 1.32621 2.58063L6.74533 7.99976L1.32621 13.4189C0.979804 13.7653 0.979804 14.3269 1.32621 14.6733C1.49942 14.8465 1.72643 14.9331 1.95339 14.9331C2.18041 14.9331 2.40742 14.8465 2.58063 14.6733L7.99974 9.25417L13.4189 14.6733C13.5921 14.8465 13.8191 14.9331 14.0461 14.9331C14.2731 14.9331 14.5001 14.8465 14.6733 14.6733C15.0197 14.3269 15.0197 13.7653 14.6733 13.4189Z","stroke":"currentColor"}})])
          )
        }
      }
    